module.exports = __webpack_public_path__ + "img/whattips.567f2056.png";